
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Download = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect x="-0.1" y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M20.6,11.6v4.3a2.2,2.2,0,0,1-2.2,2.2H4.4V11.6H2.9v8H18.4a3.7,3.7,0,0,0,3.7-3.7V11.6Z"></path>
            <polygon points="17.8 9.3 16.8 8.3 13.3 11.8 13.3 1.9 11.8 1.9 11.8 11.8 8.2 8.3 7.2 9.3 12.5 14.7 17.8 9.3"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Download.defaultProps = {
  title: 'Download',
};

export default Download;
